// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

let pollingLoopInterval;

export function register(config) {
	const swUrl = new URL('', import.meta.url).origin + '/service-worker.js';
	registerValidSW(swUrl, config);
}

function registerValidSW(swUrl, config) {
	navigator?.serviceWorker
		?.register(swUrl)
		.then((registration) => {
			pollingLoopInterval = setInterval(async () => {
				await registration.update();
			}, 1000);

			registration.onupdatefound = () => {
				const installingWorker = registration.installing;

				if (installingWorker == null) {
					return;
				}

				installingWorker.onstatechange = () => {
					if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
						// eslint-disable-next-line
						console.log(
							'New content is available and will be used when all ' +
							'tabs for this page are closed. See https://cra.link/PWA.'
						);

						// Execute callback
						if (config && config.onUpdate) {
							config.onUpdate(registration);
						}
					}
				};
			};
		})
		.catch((error) => {
			// eslint-disable-next-line
			console.error('Error during service worker registration:', error);
		});
}

export function unregister() {
	if (pollingLoopInterval) {
		clearInterval(pollingLoopInterval);
	}

	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.ready
			.then((registration) => {
				registration.unregister();
			})
			.catch((error) => {
				// eslint-disable-next-line
				console.error(error.message);
			});
	}
}
